import React, { useCallback, useState } from 'react';

import { ColumnDividerBox } from '@eika-kortbetjening/column-divider-box';
import { InfoMessage } from '@eika/attention-message';
import { LinkButton } from '@eika/button';

import { ModalState } from '@components/card/card-info-with-functionality/CardInfoWithFunctionality';
import { CreditCard, CreditCardAccount } from '@generated-types';
import useText from '@hooks/use-text';

import { CreditCardControlPanel } from './CardControlPanel';
import { DetailsPanelItems } from './DetailsPanelItems/DetailsPanelItems';

type CardDetailsPanelProps = {
    card: CreditCard;
    account: CreditCardAccount;
};

export const CardDetailsPanel = ({ card, account }: CardDetailsPanelProps) => {
    const text = useText();

    const [modalState, setModalState] = useState<ModalState>({
        showDigitalCardModal: false,
        showPinModal: false,
        showReopenCardModal: false,
        showCardActivationModal: false,
    });

    const openCardActivationModal = useCallback(() => {
        if (!card) {
            return;
        }

        setModalState({ ...modalState, showCardActivationModal: true });
    }, [modalState, setModalState, card]);

    const canActivateCard = false;

    return (
        <ColumnDividerBox>
            <ColumnDividerBox.Item noDivider>
                <CreditCardControlPanel card={card} />
            </ColumnDividerBox.Item>
            {canActivateCard && (
                <ColumnDividerBox.Item noDivider>
                    <InfoMessage
                        type="default"
                        text={text.activateInfoBox1}
                        clickableItem={<LinkButton onClick={openCardActivationModal}>Aktiver kort</LinkButton>}
                    />
                </ColumnDividerBox.Item>
            )}
            <ColumnDividerBox.Item noPadding>
                <DetailsPanelItems card={card} account={account} />
            </ColumnDividerBox.Item>
        </ColumnDividerBox>
    );
};
